import ColumnChart from "../charts/columnChart";
import DonutChart from "../charts/donutChart";
// import avatar from "../../assets/images/users/avatar-1.jpg";
import { useMemo, useState, useEffect } from "react";
import useStore from "../../hooks/useStore";
import { STATIC_GROUPS, TARGET_LABEL } from "../../constants/constants";
import { observer } from "mobx-react";
import { Accordion } from "react-bootstrap";
import { Form } from "react-bootstrap";
import WaterAccordion from "./waterAccordion";
import ShowPerformance from "../showPerformance";
import { toJS } from "mobx";
import { calculateMaxWithIncrease } from "../../utils/helpers";
import CustomSpinner from "../spinner/Spinner";

function DashboardWater({ year }) {
  // Add state for selected unit
  const [selectedUnit, setSelectedUnit] = useState("KL");
  const {
    dashboardStore: { dashboardDetails },
    companyStore: { permissibleLimit, companyData },
  } = useStore();
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  // const columnChartData = useMemo(() => {
  //   const tempData = dashboardDetails?.charts?.water;
  //   const result = ["A", "B", "C"].map((group) => {
  //     return {
  //       name: STATIC_GROUPS.water[group],
  //       data: [year - 1, year]?.map(
  //         (year) =>
  //           tempData?.[year]?.reduce((acc, curr) => ({ ...acc, ...curr }), {})[
  //             group
  //           ]?.prevValue || 0
  //       ),
  //       target: [year - 1, year]?.map(
  //         (year) =>
  //           tempData?.[year]?.reduce((acc, curr) => ({ ...acc, ...curr }), {})[
  //             group
  //           ]?.target || 0
  //       ),
  //     };
  //   });
  //   return result;
  // }, [dashboardDetails?.charts?.water, year]);


  // Conversion logic
  const convertValue = (value, fromUnit, toUnit) => {
    if (fromUnit === toUnit) return value;
    if (fromUnit === "KL" && toUnit === "ML") return value / 1000;
    if (fromUnit === "KL" && toUnit === "M3") return value * 1;
    return value;
  };

  const columnChartData = useMemo(() => {
    const tempData = dashboardDetails?.charts?.water;
    const fromUnit = "KL";
    const toUnit = selectedUnit;
    const getGroupValue = (data, year, group, key = "prevValue") => {
      const merged = data?.[year]?.reduce((acc, curr) => ({ ...acc, ...curr }), {});
      const value = merged?.[group]?.[key] || 0;
      return convertValue(value, fromUnit, toUnit);
    };
    return ["A", "B", "C"].map((group) => {
      return {
        name: STATIC_GROUPS.water[group],
        data: [year, year - 1].map((yr) => getGroupValue(tempData, yr, group, "prevValue")),
        target: [year, year - 1].map((yr) => getGroupValue(tempData, yr, group, "target")),
      };
    });
  }, [dashboardDetails?.charts?.water, year, selectedUnit]);
  

  const handleAccordionToggle = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };
  const assignedKpi = toJS(companyData)?.assignKpi?.find(
    (e) => e.kpiIdAssignKpi.name === "Water"
  );

  const limits = permissibleLimit?.filter(
    ({ kpiId, subCatId, catId, year: tempYear }) =>
      kpiId === assignedKpi?.kpiId &&
      catId === assignedKpi?.catId &&
      subCatId === assignedKpi?.subCatId &&
      tempYear == year
  );
  const doughNutChartData = useMemo(() => {
    const tempData = dashboardDetails?.charts?.water?.[year];
    const fromUnit = "KL";
    const toUnit = selectedUnit;
    const result = ["A", "B", "C"].map((group) => {
      const value = tempData?.reduce((acc, curr) => ({ ...acc, ...curr }), {})?.[group]?.prevValue || 0;
      return convertValue(value, fromUnit, toUnit);
    });
    const labels = ["A", "B", "C"].map((group) => STATIC_GROUPS.water[group]);
    return { data: result || [], labels };
  }, [dashboardDetails?.charts?.water, year, selectedUnit]);
  
  const [maxLimitValue, setMaxLimitValue] = useState(0);
  useEffect(() => {
    let allValues = [
      ...(limits?.map((ele) => {
        // Convert permissible limit values to selected unit
        if (selectedUnit === "ML") return ele.value / 1000;
        if (selectedUnit === "M3") return ele.value * 1;
        return ele.value;
      }) || []),
      ...["A", "B", "C"].flatMap((group) =>
        [year - 1, year].map((yr) => {
          const value = dashboardDetails?.charts?.water?.[yr]?.reduce((acc, curr) => ({ ...acc, ...curr }), {})[group]?.prevValue || 0;
          if (selectedUnit === "ML") return value / 1000;
          if (selectedUnit === "M3") return value * 1;
          return value;
        })
      ),
    ];
    setMaxLimitValue(Math.max(0, ...allValues) * 1.1);
  }, [dashboardDetails?.charts?.water, limits, year, selectedUnit]);

  return (
    <div className="row h-100 ">
      <div className="col-xl-12">
        <div className="card h-100 dashboard-card ">
          <div className="card-body ">
            <div className="d-flex flex-wrap align-items-start">
              <h5 className="mb-3 text-muted"> Water Report</h5>
              <div className="ms-auto">
                <Form.Select
                  value={selectedUnit}
                  onChange={e => setSelectedUnit(e.target.value)}
                  className="w-auto px-3 py-2 rounded"
                  style={{ minWidth: "100px", fontWeight: "500" }}
                >
                  <option value="KL">KL</option>
                  <option value="ML">ML</option>
                  <option value="M3">M3</option>
                </Form.Select>
              </div>
            </div>

            {dashboardDetails?.charts ? (
              <div>
                <ColumnChart
                  max={maxLimitValue}
                  data={
                    columnChartData?.map(({ data, name }) => ({
                      data,
                      name,
                    })) || []
                  }
                  unit={selectedUnit}
                  // categories={[
                  //   `FY${(year - 1).toString().slice(2)}`,
                  //   `FY${year.toString().slice(2)}`,
                  // ]}
                  categories={[`CY${year}`, `CY${year-1}`]}

                  
                  yaxis={
                    limits?.map((ele) => ({
                      y: ele.value || 0, // Target value
                      borderColor: "#FF4560",
                      label: {
                        borderColor: "#FF4560",
                        style: {
                          color: "#fff",
                          background: "#FF4560",
                        },
                        text: `${TARGET_LABEL.water[ele.group]}: ${ele.value} ${
                          ele.unitIdMaster.short_name
                        }`,
                      },
                    })) || []
                  }
                />
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center h-75">
                <CustomSpinner />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="col-md-12 h-100 mt-4  ">
        {/* achievements and target  */}
        <div className="row">
          <div className="col-md-6 mb-4">
            <ShowPerformance label="water" />
          </div>

          {/* donut chart  */}
          <div className="col-md-6 mb-4 ">
            <div className="card mb-0 h-100 dashboard-donut-card ">
              <div className="card-body ">
                <div className="d-flex flex-wrap align-items-start">
                  <h5 className="mb-3 text-muted donut-heading">
                    Water Overall Analysis
                  </h5>
                  <div className="ms-auto">
                      <div className="toolbar d-flex flex-wrap gap-2 ">
                        <div className="">
                          <p className="text-muted mb-1">Unit</p>
                          <h6 className="unit-value">
                            {selectedUnit}
                          </h6>
                        </div>
                      </div>
                  </div>
                </div>
                {dashboardDetails?.charts ? (
                  <div className="donut">
                    <DonutChart
                      data={doughNutChartData.data || []}
                      labels={doughNutChartData.labels || []}
                    />
                  </div>
                ) : (
                  <div className="d-flex align-items-center justify-content-center h-75">
                    <CustomSpinner />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Accordion
        className="dashboard-chart-accordion"
        onSelect={handleAccordionToggle}
      >
        <Accordion.Item key={`waste-accordian`} eventKey={0}>
          <Accordion.Header>
            {" "}
            {isAccordionOpen ? "See less" : "See more"}{" "}
          </Accordion.Header>
          <Accordion.Body>
            <WaterAccordion year={year} selectedUnit={selectedUnit} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default observer(DashboardWater);